<button class="drag-handle-button" dndHandle>
  <i-feather name="move"></i-feather>
</button>
<button class="toggle-maximize-button" (click)="requestToggleMaximize()">
  @if (!maximized) {
    <i-feather name="maximize"></i-feather>
  } @else {
    <i-feather name="minimize"></i-feather>
  }
</button>

<!-- here be content -->
<ng-content></ng-content>
